import React, { createContext } from 'react'
import config from '../utils/config'
import * as url from '../utils/url'
import usePKCEAuthData, { logout as cleanupSession } from '../utils/auth'
import { FormattedMessage } from 'react-intl'

export const AuthContext = createContext()

const logout = () => {
  cleanupSession()
  url.redirect(`${config().AUTH_LOGOUT_URL}?client_id=${config().AUTH_CLIENT_ID}&redirect_uri=${encodeURIComponent(config().AUTH_CALLBACK_URL)}`)
}

export default ({ children }) => {
  const token = usePKCEAuthData()

  if (!token) {
    return (
      <div>
        <FormattedMessage
          id='authenticatingMessage'
          defaultMessage='Authenticating...'
        />
      </div>
    )
  }

  return (
    <AuthContext.Provider value={{ logout }}>{children}</AuthContext.Provider>
  )
}
